import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export const modeSelector = createSelector(
  selector,
  store => store.mode,
);

export const existingIntSortSelector = createSelector(
  selector,
  store => store.sort,
);

export const enablePartnerModalSelector = createSelector(
  selector,
  store => store.showEnablePartnerModal,
);

export default selector;
